import styles from "./custom-processing-content.module.scss";

const CustomProcessingContent = ({ message, description = "Por favor, no cierres esta ventana. Esta operación puede tardar unos segundos." }) => (
	<div className={styles.container}>
		<div className={styles.spinnerWrapper}>
			<div className={styles.spinner} />
		</div>
		<p className={styles.message}>{message}</p>
		{description && <p className={styles.description}>{description}</p>}
	</div>
);

export default CustomProcessingContent;
